<template>
    <v-container
        fluid
        class="pa-6">
        <div class="headline font-weight-bold pb-4">
            {{ $t('menu.teamBuilding.events') }}
        </div>

        <event-list-view
            class="eventListView"
            :events="events"
            :pagination="pagination"/>

        <v-pagination
            class="pt-2"
            :style="{
                marginRight: '-8px'
            }"
            :value="pagination.page"
            :length="pagination.pageTotal"
            :total-visible="pagination.pageTotal"
            @input="onPaginationChanged"/>
    </v-container>
</template>

<script>
import EventListView from '@/views/EventListView'
import { getEvents } from '@/services/mock'

export default {
    name: 'EventListPage',

    components: {
        EventListView
    },

    data () {
        return {
            events: [],
            pagination: {
                page: 1,
                pageTotal: 1,
                pageTotalVisible: 6,
                itemsPerPage: 50,
                dateRange: [],
                search: '',
                status: this.$constant.ALL_STATUS
            }
        }
    },

    mounted () {
        this.getMockEventsData()
    },

    methods: {
        getMockEventsData () {
            this.events = getEvents()
        },

        onPaginationChanged () {}
    }
}
</script>

<style lang="scss" scoped>
::v-deep .v-pagination {
    justify-content: right;
    margin-right: -12px;
}
</style>
